export default [
    'Cold Storage',
    'Data Center',
    'Distribution',
    'Logistics',
    'Manufacturing',
    'Owner-User',
    'Other',
    'Showroom',
    'Vacant',
];